/* Returns a function, that, as long as it continues to be invoked, will not
* be triggered. The function will be called after it stops being called for
* N milliseconds. If `immediate` is passed, trigger the function on the
* leading edge, instead of the trailing.
* https://davidwalsh.name/javascript-debounce-function
*/

export default function debounce( callback, wait = 200, immediate = false ) {
  let timeout
  return function () {

    const context = this
    const args = arguments
    const later = function () {
      timeout = null
      if (!immediate) {
        callback.apply( context, args )
      }
    }
    const callNow = immediate && !timeout
    clearTimeout( timeout )
    timeout = setTimeout( later, wait )
    if (callNow) {
      callback.apply( context, args )
    }
  }
}

/*
var myEfficientFn = debounce(function() {
  // All the taxing stuff you do
}, 250);

window.addEventListener('resize', myEfficientFn);
*/



// WEBPACK FOOTER //
// ../app/lib/utils/debounce.js